"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
var react_router_dom_1 = require("react-router-dom");
var Desk = function () {
    return (react_1.default.createElement(styles_1.DeskStyle, null,
        react_1.default.createElement(react_router_dom_1.Link, { to: "/projets", style: { cursor: "pointer" } },
            react_1.default.createElement(styles_1.Laptop, null)),
        react_1.default.createElement(styles_1.Cactus, null),
        react_1.default.createElement(styles_1.PostIt, null,
            react_1.default.createElement(styles_1.GreenPostIt, null),
            react_1.default.createElement(styles_1.YellowPostIt, null),
            react_1.default.createElement(styles_1.OrangePostIt, null),
            react_1.default.createElement(styles_1.BluePostIt, null),
            react_1.default.createElement(styles_1.PinkPostIt, null)),
        react_1.default.createElement(styles_1.Pen, null)));
};
exports.default = Desk;
